import React, { useEffect, useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material";
import styles from "styled-components";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  root: {
    flexDirection: "row",
    alignItems: "center",
    fontSize: "18px",
  },
});
const RadioButton = ({ items, label, onChange, defaultValue, inline, col }) => {
  const [value, setValue] = useState(defaultValue);
  const classes = useStyles();
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (event) => {
    setValue(event.target.value);
    onChange(event.target.value);
  };
  return (
    <RadioWrapper col={col}>
      <FormControl component='fieldset' classes={inline && classes}>
        <FormLabel
          className={inline ? "mr-12 mt--2" : ""}
          component='legend'
        >
          {label}
        </FormLabel>
        <RadioGroup
          aria-label='label'
          name='controlled-radio-buttons-group'
          value={value || ""}
          onChange={handleChange}
        >
          {items.map((item, index) => (
            <FormControlLabel
              key={index}
              value={item.value}
              control={<StyledRadio defaultChecked={item.defaultChecked} />}
              label={item.label}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </RadioWrapper>
  );
};

export default RadioButton;
const StyledRadio = styled(Radio)({
  "&:hover": { background: "rgba(0,111,143,0.1)" },
  "&.Mui-checked": {
    color: "var(--primary-color)",
    "&:hover": { background: "rgba(0,111,143,0.1)" },
  },
});
const FormLabel = styles.div`
color:var(--tertiary-color);
`;
const RadioWrapper = styles.div`
& .MuiFormGroup-root{
    flex-direction:${(props) => (props.col ? "column" : "row")};
}
& .MuiFormControlLabel-root{
    &:not(:last-child){
    margin-right:30px;
}
}

`;
